<template lang="pug">
  ModalLayout(
    type="preloader-banner"
    :active="isVisible"
    :wrapStyle="wrapStyle"
  )
    .preloader-banner(:style="bannerStyle")
      .preloader-banner__progress
        .preloader-banner__progress-bar
      img.preloader-banner__background(src="~@/assets/img/header/banner/mlbb/preloader/bg.png")
      .preloader-banner__glow-ellipses-left
      .preloader-banner__glow-ellipses-right
      .preloader-banner__left-vignette
      .preloader-banner__bottom-fades-1
      .preloader-banner__bottom-fades-2
      .preloader-banner__bottom-fades-3
      .preloader-banner__can-glow
      img.preloader-banner__can(src="~@/assets/img/header/banner/mlbb/preloader/can.png")
      img.preloader-banner__character(src="~@/assets/img/header/banner/mlbb/preloader/accent.png")
      img.preloader-banner__cup(src="~@/assets/img/header/banner/mlbb/preloader/world-cup.png")
      img.preloader-banner__text-headline(src="~@/assets/img/header/banner/mlbb/preloader/win-text.png")
      .preloader-banner__headline
        img.preloader-banner__headline-cup(src="~@/assets/img/header/banner/mlbb/preloader/text-cup.png")
        div.preloader-banner__headline-list
          img(src="~@/assets/img/header/banner/mlbb/preloader/list.png")
        img.preloader-banner__headline-copyright(src="~@/assets/img/header/banner/mlbb/preloader/copyright.png")
        img.preloader-banner__headline-date(src="~@/assets/img/header/banner/mlbb/preloader/date.png")
</template>

<script>
import modals from '@/mixins/modals'

const W = 512
const H = 880

export default {
  name: 'ModalPreloaderBanner',
  mixins: [modals],
  data: () => ({
    isVisible: true,
    timer: null,
    remainingTime: 3 * 1000,
    scale: 1
  }),
  mounted () {
    this.startTimer()
    this.updateScale()
    window.addEventListener('resize', this.updateScale)
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },
  beforeDestroy () {
    clearTimeout(this.timer)
    window.removeEventListener('resize', this.updateScale)
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
  },
  computed: {
    bannerStyle () {
      return {
        transform: `scale(${this.scale})`,
        transformOrigin: 'top left',
        width: `${W}px`,
        height: `${H}px`,
        position: 'absolute',
        top: 0,
        left: 0
      }
    },
    wrapStyle () {
      const s = this.scale
      return {
        width: `${W * s}px`,
        height: `${H * s}px`
      }
    }
  },
  methods: {
    updateScale () {
      const s = Math.min(1, Math.min(window.innerWidth * 0.96 / W, window.innerHeight * 0.84 / H))
      this.scale = s
    },
    startTimer () {
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => { this.isVisible = false }, this.remainingTime)
    },
    handleVisibilityChange () {
      this.startTimer()
    }
  }
}
</script>
